export class HTMLUtils {
    public static SetHeight(element:HTMLElement,height:number)
    {
        element.style.height=height.toString()+'px';
    }

    public static NumberToPixels(number:any)
    {
        if(typeof number == 'string')
            return number;
        return number.toString()+'px';

    }

    public static GetOffsetTop(element:HTMLElement){
        return element.getBoundingClientRect().top + window.scrollY

    }

    public static GetOffsetLeft(element:HTMLElement){
        return element.getBoundingClientRect().left + window.scrollX

    }


    public static GetOffset(element:HTMLElement):Position{
        return {
            left:HTMLUtils.GetOffsetLeft(element),
            top:HTMLUtils.GetOffsetTop(element),
        }

    }


}

export interface Position {
    left:number;
    top:number;
}